import React from 'react';
import { FadeIn } from './FadeIn';
export function MechanismSection() {
  return <section className="py-24 bg-[#0F2027] text-white relative overflow-hidden" data-id="element-162">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-163">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-amber-500/10 blur-[100px]" data-id="element-164"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-emerald-500/10 blur-[100px]" data-id="element-165"></div>
      </div>

      <div className="container relative px-4 mx-auto max-w-3xl" data-id="element-166">
        <FadeIn data-id="element-167">
          <div className="text-center mb-12" data-id="element-168">
            <span className="inline-block px-4 py-1 mb-4 text-sm font-semibold tracking-wider text-amber-400 uppercase border border-amber-400/30 rounded-full" data-id="element-169">
              El Mecanismo Único
            </span>
            <h2 className="text-3xl font-bold md:text-4xl lg:text-5xl text-white mb-6" data-id="element-170">
              Termogénesis en Reposo (TR)
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-171">
          <div className="prose prose-lg md:prose-xl prose-invert mx-auto leading-[1.8] text-gray-300" data-id="element-172">
            <p data-id="element-173">
              Este protocolo no se enfoca en cuántas calorías quemas moviéndote,
              sino en <strong data-id="element-174">cuántas quemas existiendo</strong>.
            </p>
            <p data-id="element-175">
              A través de micro-estímulos térmicos y nutrición inversa,
              despertamos la{' '}
              <span className="text-amber-400 font-semibold" data-id="element-176">
                "Grasa Parda"
              </span>{' '}
              (tu caldera interna).
            </p>
            <div className="p-8 mt-8 bg-white/5 border border-white/10 rounded-2xl backdrop-blur-sm" data-id="element-177">
              <p className="m-0 text-white font-medium" data-id="element-178">
                Al elevar la temperatura de tu núcleo celular, obligas a tu
                cuerpo a consumir grasa acumulada para generar calor, incluso
                mientras duermes o trabajas sentado.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}